import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Feedback from '../../../../../components/mui/Feedback';
import FormComponent from './FormComponent';
import DeleteComponent from './DeleteComponent';
import { setFormData, setFormType, setIsOpenModal, setIsLoadingShow, setIsLoadingForm } from '../redux/actions/bankAction';
import usePermission from '../../../../../hooks/usePermission';
import { initialValuesBank as initialValues } from '../../../../../helpers/variablesInitialValues';

const ModalComponent = () => {
	const dispatch = useDispatch();
	const isOpenModal = useSelector( ({ bank }) => bank.isOpenModal);
	const formType = useSelector( ({ bank }) => bank.formType);
	const permissionStore = usePermission('banks.store');
	const permissionShow = usePermission('banks.show');
	const permissionDelete = usePermission('banks.delete');
	
	/**
	 *
	 * @description Execute reset formData, loading show, loading form, close modal state
	 * @return dispatch
	 *
	 */
	const handleCloseModal = async () => {
		await dispatch( setFormData(initialValues) );
		await dispatch( setFormType('') );
		await dispatch( setIsLoadingShow(false) );
		await dispatch( setIsLoadingForm(false) );
		await dispatch( setIsOpenModal(false) );
	};
	
	return (
		<Feedback.Modal
			maxWidth="sm"
			isOpen={isOpenModal}
			isClose={handleCloseModal}
			title={formType === 'delete' ? `Eliminación del banco` : 'Captación de bancos'}
		>
			{(formType === 'store' || formType === 'show') && (
				(formType === 'store' ? permissionStore : permissionShow) && (
					<FormComponent />
				)
			)}
			{formType === 'delete' && (
				permissionDelete && (
					<DeleteComponent />
				)
			)}
		</Feedback.Modal>
	);
};

export default ModalComponent;
